/** The postgame packet's pages, in update/packet/config.PARTS order (Trevor, 2026-10-09: ownership 1-2, Team KPIs 3,
 * Player KPIs 4, Rebounding 5). Every "Page x of n" in the packet counts from here, so a new part changes them all in
 * one place; the backend's test_packet checks the same total. */
export const PACKET_PAGES = { ownership: 1, team: 3, players: 4, rebounding: 5 } as const;
export const PACKET_PAGE_COUNT = 5;

export const packetPageLabel = (name: string, part: keyof typeof PACKET_PAGES) =>
  `${name} · Page ${PACKET_PAGES[part]} of ${PACKET_PAGE_COUNT}`;
